module.exports = __webpack_public_path__ + "img/18a001-08.d02f9300.png";